export const data = [
  {
    client_fc_name: "fc3",
    client_fc_type: "warehouse",
    total_quantity: 13657,
    sla: 0.273998681994582,
    total_value: 13145
  },
  {
    client_fc_name: "fc2",
    client_fc_type: "warehouse",
    total_quantity: 11925,
    sla: 0.291153039832285,
    total_value: 12717
  },
  {
    client_fc_name: "fc5",
    client_fc_type: "port",
    total_quantity: 13534,
    sla: 0.325993793409192,
    total_value: 14860
  },
  {
    client_fc_name: "fc2",
    client_fc_type: "port",
    total_quantity: 15384,
    sla: 0.327548101924077,
    total_value: 15003
  },
  {
    client_fc_name: "fc4",
    client_fc_type: "port",
    total_quantity: 14326,
    sla: 0.333589278235376,
    total_value: 14584
  },
  {
    client_fc_name: "fc4",
    client_fc_type: "warehouse",
    total_quantity: 13181,
    sla: 0.337379561490024,
    total_value: 12434
  }
];

export const mostAffectedWarehousesColumns = [
  "Warehouse",
  "WH Type",
  "SLA%",
  "Value",
  "Quantity"
];
